const STORAGE_PREFIX = 'll_exp_';

export function getExperimentVariant(key: string, variants: readonly string[]): string {
  if (typeof window === 'undefined' || variants.length === 0) {
    return variants[0] || 'A';
  }

  const storageKey = `${STORAGE_PREFIX}${key}`;
  const existing = window.localStorage.getItem(storageKey);
  if (existing && variants.includes(existing)) {
    return existing;
  }

  const randomIndex = Math.floor(Math.random() * variants.length);
  const selected = variants[randomIndex];
  window.localStorage.setItem(storageKey, selected);
  return selected;
}
